module.exports = __webpack_public_path__ + "static/fonts/Quicksand-Regular.8924d82.woff";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/Quicksand-Regular.woff
// module id = 8Rqd
// module chunks = 1